import { extractFaq } from "@acme/mdx/faq";
import type { FaqItem } from "~/lib/constants/faq";

/**
 * The question/answer pairs a blog article actually renders, for FAQPage
 * markup. The parser lives in @acme/mdx/faq so the CMS linter and the content
 * engine read FAQs exactly the way the site does; an empty list means "emit no
 * FAQPage node".
 */
export function extractBlogFaqItems(
  markdown: string | null | undefined
): FaqItem[] {
  return markdown ? extractFaq(markdown) : [];
}
